export default from './Tooltip';



// WEBPACK FOOTER //
// ./src/sharedComponents/Tooltip/index.js